import React, { Component } from "react";
import ConversionFilters from "./ConversionFilters";
import ConversionList from "../../containers/ConversionListContainer";
import { currentLocals } from "../../languages/languages.js";
import "../../styles/ConversionPanel.css";

import { Typography } from "@mui/material";

export default class ConversionPanel extends Component {
  render() {
    return (
      <div className="ConversionPanel " data-tut="reactour__conversionbar">
        {}
        <div className="ConversionPanelconversion">
          <Typography sx={{ marginLeft: 2, color: "primary.main" }} variant="h4">
            {currentLocals(this.props.locale).conversion.ConversionList}
          </Typography>
          <ConversionList />
        </div>
      </div>
    );
  }
}
